import React, { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from './../../componentes/form-grids/GridItemContainer';
import CustomAlert from './../../componentes/alerts/CustomAlert';
import GridInputRow from './../../componentes/form-grids/GridInputRow';
import { Grid, Button } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from './../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelSuccess from './../../componentes/labels/LabelSuccess';
import LabelError from './../../componentes/labels/LabelError';
import { DefaultDatagrid } from './../../componentes/datagrid/DefaultDatagrid';
import programRoleService from "./ProgramService";
import buttonStyle from "./buttonStyle";
import {
    FaHome,
    FaLink,
    FaUnlink
} from "react-icons/fa";

export default function ProgramRole() {
    const { t } = useTranslation();
    const { control } = useForm();



    const userId = sessionStorage.getItem("userId");
    const loggedUserIdRole = sessionStorage.getItem("role");

    const initialProgramRoleState = {
        idRole: 1,
        idProgram: 0,
        loggedUserId: userId,
        loggedUserIdRole: loggedUserIdRole,
    };


    const [programRole, setProgramRole] = useState(initialProgramRoleState);
    const [warningProgramRole, setWarningProgramRole] = useState(false);
    const [clearedProgramRole, setClearedProgramRole] = useState(false);
    const [programRoleRows, setProgramRoleRows] = useState([]);

    const columnsProgramRole = (t) => [
        {
            field: "idRole",
            textAlign: 'center',
            visible: false,
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="idRole" />;
            },
        },
        {
            field: "idProgram",
            textAlign: 'center',
            visible: false,
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="idProgram" />;
            },
        },
        {
            field: "menuDesc",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="menuDesc" name="menu" />;
            },
        },
        {
            field: "statusCode",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="statusCode" name="status" />;
            },
            template: (props) => {
                return (
                    <>
                        {props.statusCode ? (
                            <LabelSuccess text="accessEnabled" />
                        ) : (
                            <LabelError text="accessDenied" />
                        )}
                    </>
                );
            },
        },
        {
            field: "programDesc",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="programDesc" />;
            },
        },
        {
            field: "programLink",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="programLink" name="link" />;
            },
        },
        {
            field: "idRole",
            textAlign: 'center',
            visible: false,
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="idRole" />;
            },
        },
        {
            field: "",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="alter" />;
            },
            template: (props) => {
                const onClick = () => {
                    if (props.statusCode === 0) {
                        programRoleService
                            .create(props)
                            .then((response) => {
                                handleSearchProgramRole();
                            })
                            .catch((e) => { });
                    } else {
                        programRoleService
                            .remove(props)
                            .then((response) => {
                                handleSearchProgramRole();
                            })
                            .catch((e) => { });
                    }
                };

                const classes = buttonStyle();

                const buttonClass =
                    props.statusCode === 0 ? classes.successButton : classes.errorButton;

                return (
                    <Button onClick={() => handleToggleButton(props)} className={buttonClass}>
                        {props.statusCode === 0 ? <FaLink /> : <FaUnlink />}
                    </Button>
                );
            },
        },
    ];


    const handleChangeProgramRole = (event) => {
        const { name, value } = event.target;
        setProgramRole({ ...programRole, [name]: value });
    };

    const handleCloseAlertProgramRole = () => {
        setWarningProgramRole(false);
    };

    const handleClearProgramRole = () => {
        setClearedProgramRole(!clearedProgramRole);
        setWarningProgramRole(false);
    };

    const handleSearchProgramRole = (idRole) => {

        let request = { ...programRole }

        if (idRole) {
            request = {
                ...request,
                idRole
            }
        }

        programRoleService
            .get(request)
            .then((response) => {

                response.data.forEach((program, index) => {
                    program.id = index
                    program.idRole = request.idRole
                })
                setProgramRoleRows(response.data)
            })
            .catch((e) => {
                handleWarningProgramRole();
            });
    };

    const handleToggleButton = (props) => {
        if (props.statusCode === 0) {
            programRoleService
                .create(props)
                .then((response) => {
                    handleSearchProgramRole(props.idRole);
                })
                .catch((e) => { });
        } else {
            programRoleService
                .remove(props)
                .then((response) => {
                    handleSearchProgramRole(props.idRole);
                })
                .catch((e) => { });
        }
    }

    const handleWarningProgramRole = () => {
        setProgramRoleRows([]);
        if (programRole.idRole !== 0) {
            setWarningProgramRole(true);
        }
    };

    useEffect(() => {
        handleSearchProgramRole();
    }, [programRole.idRole]);

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="programRole"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                message={t("programRoleWarning")}
                                warning={warningProgramRole}
                                handleCloseAlert={handleCloseAlertProgramRole}
                            />
                            <GridInputRow>
                                <Grid item xs={12} sm={6}>
                                    <DefaultAutocomplete
                                        name={"idRole"}
                                        onChange={handleChangeProgramRole}
                                        value={programRole.idRole}
                                        label={t("role")}
                                        defaultSize
                                        useApi
                                        endpoint='GetProfileListAutoComplete'
                                    />
                                </Grid>
                                <Grid item>
                                    <SearchClearSaveRow
                                        onClickClear={handleClearProgramRole}
                                    />
                                </Grid>
                            </GridInputRow>
                        </GridItemContainer>
                    </>
                }
            />
            {programRoleRows.length > 0 ? (
                <DefaultScreenAccordion
                    title="programRoleGrid"
                    fields={
                        <DefaultDatagrid
                            columns={columnsProgramRole(t, handleSearchProgramRole)}
                            dataSource={programRoleRows}
                        />
                    } />
            ) : null}
        </>
    );
};
